import { IUpdateItemChecklistEntregaUseCase } from "../../../presentation/useCases/update/update_item_checklist_entrega_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * UpdateItemChecklistEntregaUseCase
 */

export class UpdateItemChecklistEntregaUseCase implements IUpdateItemChecklistEntregaUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async execute(
    idItemChecklistEntrega: number,
    descricao?: string,
    ordem?: string,
  ): Promise<void> {
    await this.repository.updateItemChecklistEntrega(
      idItemChecklistEntrega,
      descricao,
      ordem,
    );
  }
}
